import { useState } from 'react';
import { useMigrationState } from '../hooks/useMigrationState';
import MigrationMessagingBannerWithConversationsAlert from './MigrationMessagingBannerWithConversationsAlert';
import MigrationMessagingBannerNoConversationsAlert from './MigrationMessagingBannerNoConversationsAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const MigrationMessagingBanner = ({
  channel: {
    channelInstanceId,
    name,
    type
  },
  viewStatusRoute
}) => {
  const {
    moveConversations
  } = useMigrationState({
    channelInstanceId
  });
  const [bannerIsDissmissed, setBannerIsDissmissed] = useState(false);
  if (bannerIsDissmissed) return null;
  if (moveConversations) {
    return /*#__PURE__*/_jsx(MigrationMessagingBannerWithConversationsAlert, {
      name: name,
      onClose: () => setBannerIsDissmissed(true),
      type: type,
      viewStatusRoute: viewStatusRoute
    });
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBannerNoConversationsAlert, {
    name: name,
    onClose: () => setBannerIsDissmissed(true),
    type: type,
    viewStatusRoute: viewStatusRoute
  });
};
MigrationMessagingBanner.displayName = 'MigrationMessagingBanner';
export default MigrationMessagingBanner;